import React from 'react';
import {Helmet} from 'react-helmet-async';

const DEFAULT_ROBOTS='index,follow,max-image-preview:large';
const NOINDEX_ROBOTS='noindex,follow';

export default function SEO({title,description,schema,image,url,exactTitle=false,noindex=false}) {
  const resolvedTitle=exactTitle ? title : `${title} | CurateEd`;
  const robots=noindex ? NOINDEX_ROBOTS : DEFAULT_ROBOTS;
  const canonicalUrl=noindex ? null : url;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="CurateEd" />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:secure_url" content={image} />}
      {image && <meta property="og:image:alt" content={title} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {image && <meta name="twitter:image:alt" content={title} />}
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
      )}
    </Helmet>
  );
}